import Image from "next/image";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ProductBadges = () => {
  const { product } = useProductDetail();

  if (!product?.badges || product.badges.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {product.badges.map((badge, index) => (
        <div
          key={badge.id || index}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium text-white"
          style={{ backgroundColor: badge.color_hex }}
        >
          {badge.icon_full && (
            <Image
              src={badge.icon_full}
              alt={badge.label}
              width={14}
              height={14}
              className="shrink-0"
            />
          )}
          <span>{badge.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProductBadges;
